export const RoundBoxPlusTree = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <g clip-path="url(#clip0_2702_5516)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.9998 0.675049L2.9998 0.675049C1.7248 0.675049 0.674805 1.72505 0.674805 3.00005L0.674805 21C0.674805 22.275 1.7248 23.3625 3.0373 23.3625L21.0373 23.3625C22.3123 23.3625 23.3998 22.3125 23.3998 21L23.3998 3.00005C23.3623 1.72505 22.2748 0.675049 20.9998 0.675049ZM16.6498 11.175H12.8623L12.8623 7.35005C12.8623 6.90005 12.4873 6.48755 11.9998 6.48755C11.5498 6.48755 11.1373 6.86255 11.1373 7.35005L11.1373 11.1375L7.3498 11.1375C6.89981 11.1375 6.4873 11.5125 6.4873 12C6.4873 12.45 6.86231 12.8625 7.3498 12.8625L11.1373 12.8625V16.65C11.1373 17.1 11.5123 17.5126 11.9998 17.5126C12.4498 17.5126 12.8623 17.1376 12.8623 16.65V12.8625H16.6498C17.0998 12.8625 17.5123 12.4875 17.5123 12C17.4748 11.55 17.0998 11.175 16.6498 11.175Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_2702_5516">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
